import React from 'react';
import { ChevronRightIcon, ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import stripeIcon from './StripeIcon.jpg';
import styles from './Payments.module.css';

const PayoutsCard = ({ isEnabled, onClick }) => {
  return (
    <div 
      className={`${styles.actionCard} ${styles.payoutsCard} ${isEnabled ? styles.enabled : styles.disabled}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
      aria-label={isEnabled ? "View earnings and payouts" : "Payouts - setup required"}
    >
      <div className={styles.cardIconWrapper}>
        <img src={stripeIcon} alt="Stripe" className={styles.cardIcon} />
      </div>
      
      <h3 className={styles.cardTitle}>Payouts</h3>
      <p className={styles.cardDescription}>
        Track your earnings, view payout history, and monitor your revenue growth on Stripe
      </p>
      
      <button 
        className={`${styles.cardButton} ${!isEnabled ? styles.disabled : ''}`}
        disabled={!isEnabled}
        onClick={(e) => e.stopPropagation()}
        type="button"
      >
        {isEnabled ? (
          <>
            View Payouts
            <ArrowTopRightOnSquareIcon className={styles.cardArrow} />
          </>
        ) : (
          'Setup Required'
        )}
      </button>
    </div>
  );
};

export default PayoutsCard;